import React from 'react';
import { Edit, useNotify, useRedirect, DeleteButton, SaveButton, Toolbar } from 'react-admin';

import { useTitle } from '@src/hooks/useTitle';
import ConditionDiscountsForm from './ConditionDiscountsForm';

const RESOURCE_NAME = 'resale/conditions';

const ConditionDiscountsEditToolbar = () => (
  <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
    <SaveButton />
    <DeleteButton />
  </Toolbar>
);

const ConditionDiscountsEdit = () => {
  const { title } = useTitle('Edit Condition Discount Rule');
  const notify = useNotify();
  const redirect = useRedirect();

  return (
    <Edit
      title={title}
      mutationMode="pessimistic"
      mutationOptions={{
        onSuccess: () => {
          notify('Pricing rule updated successfully', { type: 'success' });
          redirect('list', RESOURCE_NAME);
        },
        onError: (error: unknown) => {
          const message = error instanceof Error ? error.message : 'Failed to update pricing rule';
          notify(`Error: ${message}`, { type: 'error' });
        },
      }}
    >
      <ConditionDiscountsForm toolbar={<ConditionDiscountsEditToolbar />} />
    </Edit>
  );
};

export default ConditionDiscountsEdit;
